<template>
    <!-- product view container -->
    <div class="card">
        <div class="card-image">
            <figure class="image is-4by3">
                <img src="https://bulma.io/images/placeholders/1280x960.png" alt="producto">
            </figure>
        </div>
        <div class="card-content">
            <div class="content">
                <p class="title is-4">{{ name }}</p>
                <!-- <p class="subtitle is-6">{{ description.slice(0,18) }}</p> -->
                <p class="subtitle is-5">${{ price }}</p>
                <b-taglist>
                    <b-tag v-for="i in (Math.floor(Math.random() * Math.floor(3))+1)" v-bind:key="i">Tag {{i}}</b-tag>
                    <!-- <b-tag type="is-info">Tag 1</b-tag>
                    <b-tag type="is-link">Tag 2</b-tag>
                    <b-tag type="is-danger">Tag 3</b-tag> -->
                </b-taglist>
            </div>
        </div>
        <footer class="card-footer">
            <b-button tag="router-link" :to="{ name: 'ProductPage', params: { idProduct: idProducto } }"  class="card-footer-item"><b-icon pack="fas" icon="eye"></b-icon></b-button>
            <b-button class="card-footer-item" @click="$emit('addToCart', idProducto)"><b-icon pack="fas" icon="cart-plus"></b-icon></b-button>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'ProductCard',
    props: ["name", "description", "idProducto","price"],
    data() {
        return {
            path: "/product"
        }
    }
}
</script>